import { GetOS, GetBrowser } from "@/utils/JSTool";

export const FromGameApp =
  navigator &&
  navigator.userAgent &&
  (navigator.userAgent.indexOf("GameApp") > -1 || navigator.userAgent.indexOf("SKGames") > -1 || navigator.userAgent.indexOf("AndroidApp") > -1) || !!localStorage.getItem("fromApp");
export const FromStandAlone = (navigator && navigator.standalone) || matchMedia("(display-mode: standalone)").matches;
export const FromIPhone = GetOS() == "iOS" && GetBrowser() == "Safari";
export const AppVersion = (navigator && navigator.userAgent && navigator.userAgent.match(/v\.(\d+\.\d+\.\d+)/) && navigator.userAgent.match(/v\.(\d+\.\d+\.\d+)/)[1]) || "0.0.0";
export const FromInstalled = FromStandAlone || FromGameApp;